import React from 'react';
import { Box, Typography } from '@mui/material';

interface EmptyStateMessageProps {
  message: string;
  minHeight?: number | string;
}

const EmptyStateMessage: React.FC<EmptyStateMessageProps> = ({ message, minHeight = 200 }) => (
  <Box
    sx={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight,
      py: 2,
    }}
  >
    <Typography variant="body2" sx={{ color: 'text.secondary', fontWeight: 500 }}>
      {message}
    </Typography>
  </Box>
);

export default EmptyStateMessage;
